import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Transaction } from '../models/transactionmodel';
import { TransactionChart } from '../models/chartmodel';
import { Stat } from '../models/statmodel';
import { Cummulative } from '../models/cummulativemodel';
import { Recon } from '../models/reconmodel';
import { Search } from '../models/searchmodel';
import { AcctResponse } from '../models/accountresponse';
import { Observable } from 'rxjs/Rx';
import { SharedService } from '../services/sharedservices.service';
import { config } from '../config/config';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class transactionService {
  //authconfig: string = config.username + ':' + config.password;
  viewconfig: string = config.viewername + ':' + config.viewerpass;
  urlbase: string = config.baseUrl + 'transactions';

  constructor(private http: Http, private sharedservice: SharedService) { }

  /*createAuthorizationHeader(headers: Headers) {
    let conversionSessionOutput = CryptoJS.AES.decrypt(localStorage.getItem("access_token"), config.key).toString(CryptoJS.enc.Utf8);
    let authconfig = this.sharedservice.session.account_username + ':' + conversionSessionOutput;
    headers.append('Authorization', 'Basic ' +
      btoa(authconfig));
  }

  createViewerAuthorizationHeader(headers: Headers) {
    headers.append('Authorization', 'Basic ' +
      btoa(this.viewconfig));
  }*/

  reconcileAllTransaction(recons: Transaction[]) {

    recons.forEach(trans => {
      const headers = new Headers();
      const data = JSON.stringify(trans);

      console.log('data : ' + data);

      //this.createAuthorizationHeader(headers);
      headers.append('Content-Type', 'application/json');

      this.http.post(this.urlbase + '/recon', data, {
        headers: headers,
        withCredentials: true
      })

    });

  }

  reconcileTransaction(recon: Recon): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(recon);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.urlbase + '/recon', data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }

  searchTransaction(search: Search): Observable<Transaction[]> {
    const headers = new Headers();


    if (!this.sharedservice.isAdmin() && !this.sharedservice.isViewer()) {
      if (this.sharedservice.isMerchant()) {
        search.searchstoreid = this.sharedservice.session.account_username;
      }
      else {
        search.searchstoreid = this.sharedservice.session.account_userstore;
      }
    }

    const data = JSON.stringify(search);

    /*if (this.sharedservice.isViewer()) {
      this.createAuthorizationHeader(headers);
    }
    else {
      this.createAuthorizationHeader(headers);
    }*/

    headers.append('Content-Type', 'application/json');

    return this.http.post(this.urlbase + '/search', data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getLast10Transactions(): Observable<Transaction[]> {
    var url;
    const headers = new Headers();

    if (this.sharedservice.isAdmin())
      url = this.urlbase + "/last";
    else if (this.sharedservice.isViewer())
      url = this.urlbase + "/last";
    else if (this.sharedservice.isMerchant())
      url = this.urlbase + "/last/auth";
    else
      url = this.urlbase + "/last/auth";


    /*if (this.sharedservice.isViewer()) {
      this.createAuthorizationHeader(headers);
    }
    else {
      this.createAuthorizationHeader(headers);
    }*/

    return this.http.get(url, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getCummulative(period: string): Observable<Cummulative[]> {
    var url;
    const headers = new Headers();

    if (this.sharedservice.isAdmin())
      url = this.urlbase + "/cummulative/all/" + period;
    else if (this.sharedservice.isViewer())
      url = this.urlbase + "/cummulative/all/" + period;
    else if (this.sharedservice.isMerchant())
      url = this.urlbase + "/cummulative/" + period+"/auth";
    else
      url = this.urlbase + "/cummulative/" + period+"/auth";


    // this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getTransactions(): Observable<Transaction[]> {
    var url;
    const headers = new Headers();

    if (this.sharedservice.isAdmin())
      url = this.urlbase;
    else if (this.sharedservice.isViewer())
      url = this.urlbase;
    else if (this.sharedservice.isMerchant())
      url = this.urlbase + "/auth";
    else {
      url = this.urlbase + "/auth";
    }

    // this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getChartTransactions(): Observable<TransactionChart[]> {
    var url;
    const headers = new Headers();

    if (this.sharedservice.isAdmin())
      url = this.urlbase + '/chart';
    else if (this.sharedservice.isMerchant())
      url = this.urlbase + '/chart/auth';
    else
      url = this.urlbase + '/chart/auth';

    // this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getStatTransactions(): Observable<Stat[]> {
    var url;
    const headers = new Headers();

    if (this.sharedservice.isAdmin())
      url = this.urlbase + '/stats';
    else if (this.sharedservice.isMerchant())
      url = this.urlbase + '/stats/auth';
    else
      url = this.urlbase + '/stats/auth';


    // this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers, withCredentials : true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    //console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/transaction.service.ts